const { getSupportChannelOptions } = require('@/tools');
const { CHANNEL_INTERFACE_TYPE } = require('@/enums');

module.exports = (s) => {
  return {
    channel_interface: {
      label: '媒体平台',
      type: 'select',
      value: '',
      rules: [
        {
          required: true,
          message: '请选择媒体平台',
          trigger: ['change'],
        },
      ],
      options: (() => {
        /** 目前支持的渠道媒体 */
        const options = getSupportChannelOptions();
        /**
         * 置顶的渠道媒体索引
         * 产品要求广点通排在选项第一位
         */
        const top_index = options.findIndex(option => option.value === CHANNEL_INTERFACE_TYPE.GDT);
        top_index !== -1 && options.unshift(options.splice(top_index, 1)[0]);
        return options;
      })(),
      props: {
        disabled: false,
        clearable: false,
      },
      on: {
        change(val) {
          s.onChannelChange(val);
        },
      },
    },
    advertiser_ids: {
      label: '广告主账户',
      type: 'select-v2',
      value: [],
      rules: [
        {
          required: true,
          message: '请选择广告主账户',
          trigger: ['change'],
        },
      ],
      props: {
        disabled: false,
        clearable: false,
        placeholder: '请选择广告主账户',
        multipleLimit: 10,
        multiple: true,
        type: 'panel',
        collapseTags: true,
        style: {
          width: '350px',
        },
      },
      options: [],
    },
    ad_type: {
      label: '广告类型',
      type: 'select',
      value: 'show_ad',
      rules: [
        {
          required: true,
          message: '请选择广告类型',
          trigger: ['change'],
        },
      ],
      options: [
        {
          label: '展示广告',
          value: 'show_ad',
        },
      ],
      props: {
        disabled: false,
        clearable: false,
      },
    },
    action: {},
    add_creative: {
      hidden: true,
    },
    template: {
      formItemProps: {
        class: 'fr',
      },
    },
  };
};
